<div class="addlocation-subselection">
  <div class="district-heading">{{ selectedFilter | uppercase }}</div>
  <div class="selection">
    <div class="subselection-header"></div>
    <span *ngIf="subSectionList && subSectionList.length > 0; else norecords" class="filter-labels">
      <mat-checkbox
        (change)="selectAll($event)"
        [disabled]="InputLength > 1"
        [checked]="selectAllFields"
        l10nTranslate
        class="select-all-checkbox"
      >
        shared.selectAll
      </mat-checkbox>
      <div class="filter-section" *ngIf="selectedFilter">
        <div *ngFor="let data of subSectionList" class="filter-labels">
          <mat-checkbox
            [(ngModel)]="data.checked"
            (change)="onSelectionChange(data, $event)"
            [checked]="selectAllFields || data.checked"
            [disabled]="InputLength > 1"
          >
            {{ data.value | titlecase }}
          </mat-checkbox>
        </div>
      </div>
    </span>
    <ng-template #norecords>
      <span class="norecords" l10nTranslate> shared.noRecords</span>
    </ng-template>
  </div>
</div>
